import type {ReactRef} from 'src/types/react';
import {useEffect} from 'react';


export function useOnClickOutside(
  ref: ReactRef<HTMLElement>,
  handler: (event: MouseEvent) => void,
) {
  useEffect(() => {
    const listener = (event: any) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    window.addEventListener('mousedown', listener);
    window.addEventListener('touchstart', listener);
    return () => {
      window.removeEventListener('mousedown', listener);
      window.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}
